import { render, staticRenderFns } from "./SurveyorAcknowledgmentSection.vue?vue&type=template&id=b4a24d1e&scoped=true"
import script from "./SurveyorAcknowledgmentSection.vue?vue&type=script&lang=js"
export * from "./SurveyorAcknowledgmentSection.vue?vue&type=script&lang=js"
import style0 from "./SurveyorAcknowledgmentSection.vue?vue&type=style&index=0&id=b4a24d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a24d1e",
  null
  
)

export default component.exports